import { render, staticRenderFns } from "./name-hospital-dialog.vue?vue&type=template&id=07de1be1&scoped=true"
import script from "./name-hospital-dialog.vue?vue&type=script&lang=js"
export * from "./name-hospital-dialog.vue?vue&type=script&lang=js"
import style0 from "./name-hospital-dialog.vue?vue&type=style&index=0&id=07de1be1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07de1be1",
  null
  
)

export default component.exports